import React, { memo, useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import Cookies from 'universal-cookie'
import TextField from '@mui/material/TextField'
import FormControlLabel from '@mui/material/FormControlLabel'
import Switch from '@mui/material/Switch'
import { MdClose } from 'react-icons/md'
import AVDeviceTable from '../../Settings/AVDeviceTable'
import { VideoTest } from '../../Settings/VideoTest'
import { BrandedButton } from '../BrandedButton/BrandedButton.component'
import { NotificationContext } from '../../../context/Shared/Notification.context'
import styles from './KioskSettings.module.scss'

const ONE_YEAR = 1000 * 60 * 60 * 24 * 365

const KioskSettings = ({ onClose }) => {
  const { t } = useTranslation()
  const { setSnackBarMessage } = useContext(NotificationContext)

  const cookies = new Cookies()
  const [viscaServer, setViscaServer] = useState(
    cookies.get('visca') || 'http://localhost:9131'
  )
  const [flipH, setFlipH] = useState(
    cookies.get('viscaFlipH') === true || cookies.get('viscaFlipH') === 'true'
  )
  const [flipV, setFlipV] = useState(
    cookies.get('viscaFlipV') === true || cookies.get('viscaFlipV') === 'true'
  )

  const saveVisca = () => {
    const c = new Cookies()
    c.set('visca', viscaServer, { maxAge: ONE_YEAR })
    c.set('viscaFlipH', flipH, { maxAge: ONE_YEAR })
    c.set('viscaFlipV', flipV, { maxAge: ONE_YEAR })
    setSnackBarMessage(t('Saved'), 'success')
  }

  return (
    <div className={styles.kioskSettings}>
      <div className={styles.kioskSettings__card}>
        <div className={styles.kioskSettings__header}>
          <h2 className={styles.kioskSettings__title}>{t('Settings')}</h2>
          <button
            type="button"
            className={styles.kioskSettings__close}
            onClick={onClose}
            aria-label={t('Close')}
          >
            <MdClose />
          </button>
        </div>

        <div className={styles.kioskSettings__body}>
          <section className={styles.kioskSettings__section}>
            <h3 className={styles.kioskSettings__sectionTitle}>
              {t('Cameras & Microphones')}
            </h3>
            <p className={styles.kioskSettings__hint}>
              {t('Enable or disable devices, set defaults, and test each feed.')}
            </p>
            <AVDeviceTable />
          </section>

          <section className={styles.kioskSettings__section}>
            <h3 className={styles.kioskSettings__sectionTitle}>
              {t('Camera IP (PTZ)')}
            </h3>
            <p className={styles.kioskSettings__hint}>
              {t('Select a camera and set its IP address to enable PTZ controls.')}
            </p>
            <VideoTest />
          </section>

          <section className={styles.kioskSettings__section}>
            <h3 className={styles.kioskSettings__sectionTitle}>
              {t('PTZ / VISCA Server')}
            </h3>
            <div className={styles.kioskSettings__viscaRow}>
              <TextField
                label={t('VISCA Server')}
                variant="outlined"
                size="small"
                value={viscaServer}
                onChange={(e) => setViscaServer(e.target.value)}
                sx={{ minWidth: 280 }}
              />
              <FormControlLabel
                control={
                  <Switch
                    checked={flipH}
                    onChange={(e) => setFlipH(e.target.checked)}
                    color="primary"
                  />
                }
                label={t('Flip Pan (Left/Right)')}
              />
              <FormControlLabel
                control={
                  <Switch
                    checked={flipV}
                    onChange={(e) => setFlipV(e.target.checked)}
                    color="primary"
                  />
                }
                label={t('Flip Tilt (Up/Down)')}
              />
              <BrandedButton onClick={saveVisca} buttonLabel={t('Save')} />
            </div>
          </section>
        </div>
      </div>
    </div>
  )
}

KioskSettings.propTypes = {
  onClose: PropTypes.func.isRequired
}

export default memo(KioskSettings)
